import * as React from "react";

import { NdsSverkaParams, NdsSverkaResult } from "../../../../../../Common/NdsPlusApiClient/INdsPlusApiClient";

import { NdsSverkaCheckPanel } from "./NdsSverkaCheckPanel";
import { NdsSverkaCheckResult } from "./NdsSverkaTypes";

export interface NdsSverkaCheckWrapperProps {
    setErrHeaderOffset: (offset: number) => void;
    getSverkaNdsPlusParamsFromFuf: () => NdsSverkaParams;
    getNdsSverkaPageUrl: (params: NdsSverkaParams) => string;
    fetchCheckStatus: (params: NdsSverkaParams) => Promise<NdsSverkaResult>;
}

export const NdsSverkaCheckWrapper = (props: NdsSverkaCheckWrapperProps) => {
    const [status, setStatus] = React.useState<NdsSverkaCheckResult>({ status: "inactive" });
    const [redirectUrl, setRedirectUrl] = React.useState<string>();

    async function makeRequestToSverka(): Promise<void> {
        const { inn, kpp, periodYear, formattedPeriodNumber } = props.getSverkaNdsPlusParamsFromFuf();
        let nextStatus = status;

        if (inn && periodYear && formattedPeriodNumber) {
            setRedirectUrl(
                props.getNdsSverkaPageUrl({
                    inn: inn,
                    kpp: kpp,
                    periodYear: periodYear,
                    formattedPeriodNumber: formattedPeriodNumber,
                })
            );
            nextStatus = await updateStatus({
                inn: inn,
                kpp: kpp,
                periodYear: periodYear,
                formattedPeriodNumber: formattedPeriodNumber,
            });
        } else {
            nextStatus = { status: "inactive" };
        }

        setStatus(nextStatus);

        if (nextStatus.status === "loading") {
            setTimeout(() => makeRequestToSverka(), 6000);
        }
    }

    function isReady(r: NdsSverkaResult): boolean {
        return !!(r && (r.result?.invoices_counters || r.error));
    }

    async function updateStatus(params: NdsSverkaParams): Promise<NdsSverkaCheckResult> {
        try {
            const ndsPlusReport = await props.fetchCheckStatus(params);

            if (!isReady(ndsPlusReport)) {
                return { status: "loading" };
            }

            if (!ndsPlusReport.result?.invoices_counters?.length && !ndsPlusReport.error) {
                return { status: "ndsError", errorMsg: "Не удалось свериться" };
            }

            if (ndsPlusReport.error === "ORG_NOT_FOUND") {
                return { status: "inactive" };
            }

            if (ndsPlusReport.error) {
                return { status: "ndsError" };
            }

            const diffsCount = ndsPlusReport.result?.invoices_counters?.reduce((sum, i) => sum + +i.diff, 0);
            if (diffsCount && diffsCount > 0) {
                return { status: "hasErrors", diffsCount: diffsCount };
            }

            return { status: "noErrors" };
        } catch {
            return { status: "serverError" };
        }
    }

    React.useEffect(() => {
        setStatus({ status: "loading" });
        setTimeout(() => makeRequestToSverka(), 1000);

        return () => {
            setStatus({ status: "inactive" });
        };
    }, []);

    if (status.status === "inactive") {
        return null;
    }

    return (
        <NdsSverkaCheckPanel
            checkResult={status}
            ndsSverkaRedirectUrl={redirectUrl}
            setAdditionalOffset={props.setErrHeaderOffset}
        />
    );
};
